<template>
    <div>
        <header-page
                @goToFilteredArticlePage="goToFilteredArticlePage"
        ></header-page>
        <div
                v-if="rubrics && articles"
                class="body_zone separator-t-g2 p-t-16 p-b-32 p-r-20 p-l-20"
        >
            <div class="d-flex justify-content-center">
                <div class="col-md-10 col-lg-10 col-xl-8 col-xxl-8">
                    <ul class="list-group list-group-flush">
                        <router-link
                                v-for="article in parsed_rubric_articles"
                                :key="article.id"
                                :to="`article?r=${article.rubric_id}&a=${article.id}`"
                                custom v-slot="{ navigate }"
                        >
                            <div
                                    class="list-group-item list-group-item-action"
                                    @click="navigate"
                            >
                                <div class="card-body style_cursor">
                                    <div class="card-text css_StyleText21">{{article.content_by_lang.title}}</div>
                                </div>
                            </div>
                        </router-link>
                    </ul>
                </div>
            </div>
        </div>
        <footer-page />
    </div>
</template>

<script>
import {computed /*, ref, watch, onBeforeMount,, reactive, computed*/} from 'vue'
import {useRouter} from 'vue-router'
import { storeToRefs } from 'pinia'

import HeaderPage from "../../shared/components/HeaderPage";
import FooterPage from "../../shared/components/FooterPage";
import {useClientStorage, useRubricArticleStore} from "../../stores/store";
import {InitStates} from "../../shared/services/init";

export default {
    props: {},
    setup() {
        const router = useRouter();

        InitStates();

        const clientStorage = useClientStorage();

        const lang = clientStorage.clientObj.lang;

        const rubricArticleStore = useRubricArticleStore();
        const { rubrics, nav_rubric_name, articles, rubric_articles } = storeToRefs(rubricArticleStore);

        const goToFilteredArticlePage = (new_filter_text) => {
            router.push({name: 'filtered-articles', params: {filter_text: new_filter_text}})
        }

        const parsed_rubric_articles = computed(() => {
          return rubric_articles.value.filter(x => x.content_lang[lang]?.status == 1)
        })

        return {
            rubrics,
            articles,
            parsed_rubric_articles,
            nav_rubric_name,
            goToFilteredArticlePage
        }
    },
    components: {HeaderPage, FooterPage}
}
</script>

<style scoped>
.body_zone, .list-group-item{
  background-color: #f8faff;
}
</style>